export const SUPPORTED_LANGUAGES = ["en", "de", "es", "fr", "it", "pt", "ja"]
